import util from '@bmp-vue/core/api/util'

const controller = 'Operadores'
export default Object.assign({}, util.GetCrud(controller, null), {
  SolicitarLinkSenha: function (dto) {
    return util.Axios.Post(controller + '/SolicitarLinkSenha', dto)
  },
  RecuperarSenha: function (dto) {
    return util.Axios.Post(controller + '/RecuperarSenha', dto)
  },
  ValidaTokenSenha: function (username, token) {
    const params = { username: username, token: token }
    return util.Axios.GetParams(controller + '/ValidaTokenSenha', params)
  },
  Combo: function () {
    return util.Axios.Get(controller + '/Combo')
  },
  SolicitarRegistroMfaFisico: function (email) {
    return util.Axios.Post(controller + `/mfafisico/solicitar/${email}`, {})
  },
  RegistrarMfaFisico: function (dto) {
    return util.Axios.Post(controller + '/mfafisico/registrar', dto)
  }
})
